{
  "global.siteDescription": "Расскажите о себе за 30 секунд, чтобы вас быстро узнали и поняли.",
  "global.languageSwitch": "Переключить язык",
  "global.languageCurrent": "Текущий язык: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "Закрыть",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.delete": "Удалить",
  "common.edit": "Редактировать",
  "common.manage": "Управление",
  "common.login": "Войти",
  "common.logout": "Выйти",
  "common.loggingOut": "Выход из системы",
  "common.logoutRetry": "Повторить попытку выхода",
  "common.preview": "Предварительный просмотр",
  "common.email": "Email",
  "common.inviteCode": "Пригласительный код",
  "common.loading": "Загрузка",
  "editor.publish.processing": "Обработка всё ещё продолжается",
  "common.localDraft": "Локальный черновик",
  "common.publicBeta": "Публичная бета-версия",
  "common.serviceStatus": "Состояние сервиса",
  "common.optional": "Необязательно",
  "common.page": "Страница",
  "common.reason": "Причина",
  "common.description": "Подробности",
  "common.submit": "Отправить",
  "nav.login": "Войти",
  "nav.draftFirst": "Начать черновик",
  "home.action.create": "Создать мою страницу",
  "home.action.continue": "Продолжить",
  "home.action.manage": "Управлять профилем",
  "home.action.agent": "Agent напишет за вас",
  "home.meta.title": "30s.to — 30 секунд, чтобы узнать вас.",
  "home.meta.description": "Когда идёшь своим путём, особенно важно рассказать о себе. 30 секунд, чтобы узнать вас. Кто вы, чем занимаетесь, что уже сделали и какими ресурсами можете поделиться. Помогите другим найти то, что им интересно, и наладить контакт с вами.",
  "home.title": "30 секунд,\nчтобы узнать вас.",
  "home.freeNote": "Создавайте, публикуйте и делитесь. Бесплатно навсегда.",
  "home.kicker": "Когда идёшь своим путём, особенно важно рассказать о себе.",
  "home.value.copy": "Кто вы, чем занимаетесь, что уже сделали и какими ресурсами можете поделиться. Помогите другим найти то, что им интересно, и наладить контакт с вами.",
  "home.features.label": "Возможности",
  "home.features.time.tab": "Читается за 30 секунд",
  "home.why.copy": "Пишите только самое важное. Чем длиннее рассказ, тем меньше людей дочитают его до конца. 30 секунд — в самый раз.",
  "home.principle.expression.title": "Выражайте себя",
  "home.principle.expression.copy": "Организуйте свой опыт, работы, идеи и ресурсы по-своему. Расскажите то, что хотите показать другим о себе.",
  "home.principle.link.title": "Ваша личная ссылка 30s.to",
  "home.principle.link.copy": "30s.to/@you — коротко, легко запомнить и сразу понятно: узнать вас за 30 секунд.",
  "home.principle.theme.title": "Разные темы для самовыражения",
  "home.principle.theme.copy": "Лаконично, в стиле ретро или ярко и смело. Выберите тему, которая вам близка, чтобы ваш стиль был заметен с первого взгляда.",
  "home.footer.tagline": "Меньше слов — больше внимания к главному.",
  "home.footer.navigation": "Навигация в нижнем колонтитуле",
  "home.demo.linkNotice": "Это демо-ссылка. Создайте свое 30-секундное вступление и добавьте свое собственное.",
  "home.demo.profile.name": "Майя Чен",
  "home.demo.profile.identity": "Независимый дизайнер продуктов, превращающий сложные проблемы в простые продукты",
  "home.demo.profile.tag.product": "Дизайн продукта",
  "home.demo.profile.tag.indie": "Инди-продукты",
  "home.demo.profile.tag.ai": "AI инструменты",
  "home.demo.profile.body": "## Сейчас\nСоздаю Briefly, чтобы независимые дизайнеры меньше переносили заметки и больше понимали людей. До проектирования прохожу реальную задачу вместе с пользователем.\n\n## Мой путь\n2020–2023: дизайн редактора и знакомства с продуктом в команде ПО для совместной работы. Вместе с инженерами разбивали сложные операции на понятные шаги.\n\nС 2024 года — независимые исследования и дизайн взаимодействия для небольших команд, параллельно развиваю свои продукты.\n\n## Проекты\n- [Relay](https://example.com/projects/relay): мой дизайн журнала решений объединяет выводы, причины и ответственных, помогая новым участникам понять контекст.\n- [Briefly](https://example.com/projects/briefly): небольшой пилот. Группирует интервью по темам с отслеживаемыми источниками и сохраняет цитаты для проверки выводов.\n\n## Чем могу поделиться\nЕсть отзывы, но непонятно, что менять сначала? Помогу сформулировать проблему и подготовить прототип для проверки. Также делюсь планами интервью и шаблонами заметок с командами, начинающими исследования.\n\n## Поговорим\nХочу обсуждать первые интервью, компромиссы и независимую работу с авторами продуманных небольших продуктов. По выходным заглядываю в соседние магазины: рукописный прейскурант порой учит ясности лучше инструкции.",
  "home.demo.profile.link.website": "Работа",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "Забронировать чат",
  "handleStart.kicker": "Публичный URL",
  "handleStart.title": "Выберите URL на 30s.to",
  "handleStart.copy": "Сначала выберите запоминающийся URL, а затем напишите представление на 30 секунд. Существующий черновик сохранится.",
  "handleStart.label": "Ваш URL",
  "handleStart.help.empty": "4-24 строчные буквы. Это сохраняет только черновик; наличие подтверждено при публикации.",
  "handleStart.help.ok": "Формат выглядит хорошо. Доступность проверяется еще раз при публикации.",
  "handleStart.submit": "Продолжить писать",
  "handleAvailability.checking": "Проверяем этот URL…",
  "handleAvailability.available": "Доступно сейчас. Он станет вашим после успешной публикации.",
  "handleAvailability.owned": "Этот адрес уже принадлежит вам.",
  "handleAvailability.assigned": "Этот адрес закреплен за вами и вступает в силу после публикации.",
  "handleAvailability.failed": "Не удалось проверить этот URL. Попробуйте ещё раз.",
  "handleAvailability.rateLimited": "Слишком много проверок. Повторите попытку через {minutes} мин.",
  "handleAvailability.retry": "Проверить снова",
  "handleAvailability.suggestions": "Также можно попробовать",
  "handleAvailability.cooldown": "Публичный URL ещё находится в 30-дневном периоде ожидания. Его можно будет изменить после {date} или восстановить текущий опубликованный URL.",
  "editor.shell.loading": "Загрузка создания потока",
  "editor.shell.workspace": "30-секундное вводное рабочее пространство",
  "editor.shell.canvas": "30-секундная поверхность для письма",
  "editor.command.aria": "Панель команд редактора",
  "editor.command.publish": "Публиковать",
  "editor.command.publishUpdate": "Опубликовать изменения",
  "editor.command.publishSettings": "Настройки публикации",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "Опубликовано",
  "editor.publish.successAfterLogin": "Вошли в систему и опубликовали",
  "editor.publish.publishing": "Публикация…",
  "editor.publish.publishingDetail": "Готовим вашу публичную страницу. Пожалуйста, подождите.",
  "editor.publish.successDetail": "Публичная страница обновлена и готова к просмотру.",
  "editor.publish.viewPublic": "Открыть публичную страницу",
  "editor.publish.cacheFailed": "но запись в кеш общедоступной страницы не удалась.",
  "editor.command.login": "Авторизоваться",
  "editor.handle.editTitle": "Изменить публичный адрес",
  "editor.handle.claimAfterPublish": "Ваш после публикации",
  "editor.handle.claimAfterPublishTitle": "Этот адрес станет вашим после публикации",
  "editor.status.signedIn": "Вошёл в систему",
  "editor.status.account": "Аккаунт: {email}",
  "editor.status.localTitle": "Местный проект",
  "editor.status.localCopy": "Этот черновик сохраняется только на этом устройстве. Войдите, чтобы синхронизировать его с облаком.",
  "editor.status.location": "Сохранить местоположение",
  "editor.status.state": "Сохранить статус",
  "editor.status.emailLogin": "Email вход",
  "editor.autosave.savingShort": "Сохранение",
  "editor.autosave.savedCloudShort": "Сохранено в облаке",
  "editor.autosave.savedLocalShort": "Сохранено локально",
  "editor.autosave.failedShort": "Сохранить не удалось",
  "editor.autosave.signedInShort": "Вошёл в систему",
  "editor.autosave.cloud": "Облако",
  "editor.autosave.retry": "Требуется повторная попытка",
  "editor.autosave.device": "Это устройство",
  "editor.autosave.saving": "Автосохранение...",
  "editor.autosave.savedLocal": "Автоматически сохраняется локально",
  "editor.autosave.savedCloud": "Автоматически сохраняется в облаке",
  "editor.autosave.authExpired": "Сессия истекла. Сохранено локально.",
  "editor.autosave.cloudFailed": "Сохранение в облаке не удалось. Сохранено локально.",
  "editor.autosave.cloudUnavailable": "Облачное сохранение пока не подключено. Сохранено локально.",
  "editor.autosave.failed": "Автосохранение не удалось. Скопируйте содержимое и повторите попытку.",
  "editor.autosave.enabled": "Автосохранение включено",
  "identity.namePlaceholder": "Ваше имя",
  "identity.nameAria": "Имя или псевдоним",
  "identity.identityPlaceholder": "Однострочный идентификатор",
  "identity.identityAria": "Однострочный идентификатор",
  "identity.tagsAria": "Теги",
  "identity.addTag": "Добавить тег",
  "identity.removeTag": "Удалить тег {tag}",
  "body.emptyInstruction": "Напишите самое важное, что стоит узнать о вас при первом знакомстве.\nПишите меньше, чтобы заметили главное. 30 секунд — в самый раз.",
  "body.templatesLabel": "Можно также начать с шаблона",
  "body.templatesAria": "Шаблоны ролей для текста",
  "body.templateExampleLabel": "Пример профиля",
  "body.viewTemplateExample": "Посмотреть пример",
  "links.sectionAria": "Ссылки",
  "links.documentTitle": "Ссылки",
  "links.documentCopy": "Социальные профили, бронирование и контактные данные",
  "links.documentEmptyCopy": "Добавьте профиль в социальной сети, страницу бронирования или способ связи. Вы можете изменить их в любое время.",
  "links.add": "Добавить ссылку",
  "links.addType": "Добавить {label}",
  "links.edit": "Редактировать {label}",
  "links.addedAria": "Добавлены ссылки",
  "links.closePanel": "Закрыть редактор ссылок",
  "links.editTitle": "Изменить ссылку",
  "links.addTitle": "Добавить ссылку",
  "links.chooseTypeAgain": "Выберите тип ссылки еще раз",
  "links.calendarProvider": "Поставщик бронирования",
  "links.displayName": "Отображаемое имя",
  "links.duplicate": "{label} уже добавлен.",
  "links.alreadyAdded": "{label} уже добавлен",
  "links.bookingAlreadyAdded": "Бронирование уже добавлено",
  "links.remove": "Удалить",
  "links.category.social": "Социальные",
  "links.category.booking": "Бронирование",
  "links.category.work": "Работы / сайты",
  "links.category.content": "Содержание",
  "links.category.contact": "Контакт",
  "links.category.other": "Другой",
  "links.type.x": "Х",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "Сяохуншу",
  "links.type.wechat": "Официальный аккаунт WeChat",
  "links.type.email": "Email",
  "links.type.calendar": "Бронирование",
  "links.type.website": "Сайт",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "Джике",
  "links.type.other": "Другой",
  "links.input.x": "Имя пользователя в X",
  "links.input.github": "Имя пользователя GitHub",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Имя пользователя Instagram",
  "links.input.youtube": "Имя пользователя YouTube",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Профиль Сяохуншу URL",
  "links.input.wechat": "Идентификатор официального аккаунта WeChat",
  "links.input.email": "Email",
  "links.input.calendar": "Путь бронирования",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "Имя пользователя TikTok",
  "links.input.threads": "Имя пользователя Threads",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Имя пользователя Dribbble",
  "links.input.jike": "Профиль Jike URL",
  "links.input.other": "Ссылка URL",
  "links.input.calendar.cal": "Путь Cal.com",
  "links.input.calendar.calendly": "Календарный путь",
  "links.input.calendar.google": "Страница бронирования Google Calendar",
  "links.input.calendar.microsoft": "ссылка Microsoft Bookings",
  "links.input.calendar.hubspot": "ссылка HubSpot Meetings",
  "links.input.calendar.savvycal": "Путь SavvyCal",
  "links.input.calendar.tidycal": "Путь TidyCal",
  "links.input.calendar.zcal": "zcal путь",
  "links.hint.handle": "Введите только дескриптор, а не URL.",
  "links.hint.uid": "Введите только UID, а не профиль URL.",
  "links.hint.slug": "Введите только путь, а не полный URL.",
  "links.hint.email": "Это создаст ссылку mailto.",
  "links.hint.text": "При нажатии на общедоступную страницу копируется это значение.",
  "links.hint.url": "Введите действительную ссылку https:// для этой платформы.",
  "links.hint.calendarSlug": "Введите только имя пользователя или путь бронирования, а не полный URL.",
  "links.hint.calendarUrl": "Введите полную страницу бронирования URL для этой платформы.",
  "rich.toolbarAria": "Панель форматирования текста",
  "rich.heading": "Заголовок раздела",
  "rich.paragraph": "Параграф",
  "rich.bold": "Смелый",
  "rich.boldFallback": "жирный текст",
  "rich.italic": "Курсив",
  "rich.italicFallback": "курсивный текст",
  "rich.code": "Встроенный код",
  "rich.comment": "Переключить комментарий",
  "rich.ul": "Маркированный список",
  "rich.ol": "Нумерованный список",
  "rich.link": "Связь",
  "rich.linkPrompt": "Введите https:// или ссылку mailto:",
  "rich.linkInvalid": "Ссылки поддерживают только https:// или mailto:",
  "rich.linkFallback": "текст ссылки",
  "rich.aria": "30-секундное вступление",
  "rich.more": "Другие форматы",
  "rich.quote": "Цитата",
  "rich.strikethrough": "Зачёркнутый",
  "rich.strikethroughFallback": "зачёркнутый текст",
  "rich.codeBlock": "Блок кода",
  "rich.codeBlockFallback": "код",
  "rich.taskList": "Список задач",
  "rich.table": "Таблица",
  "rich.tableSkeleton": "| Элемент | Описание |\n| --- | --- |\n| Элемент один | Описание один |\n| Элемент два | Описание два |",
  "rich.indent": "Увеличить отступ",
  "rich.outdent": "Уменьшить отступ",
  "rich.placeholder": "Напишите вступление Markdown, которое можно будет прочитать за 30 секунд...",
  "feedback.aria": "Написание отзыва",
  "feedback.timeTitle": "Примерное время чтения",
  "feedback.preview": "Предварительный просмотр",
  "feedback.previewMenu": "Открыть меню предварительного просмотра",
  "feedback.openAcceptancePreview": "Открыть предварительный просмотр принятия",
  "feedback.acceptancePreviewCopy": "Посмотреть результат общедоступной страницы на этом устройстве",
  "feedback.noIssues": "Никаких проблем с блокировкой",
  "feedback.prePublish": "Предварительная публикация чеков",
  "feedback.ready": "Нет блокировщиков",
  "feedback.itemCount": "{count} предметы",
  "feedback.valid": "Контент проходит проверку публикации.",
  "issue.action.displayName": "Добавить имя",
  "issue.action.oneLineIdentity": "Добавить личность",
  "issue.action.tags": "Добавить теги",
  "issue.action.body": "Вернуться к тексту",
  "issue.action.handle": "Выберите адрес",
  "issue.action.links": "Управление ссылками",
  "issue.action.view": "Вид",
  "issue.short.displayName": "Отсутствует имя",
  "issue.short.oneLineIdentity": "Отсутствует личность",
  "issue.short.tags": "Отсутствующие теги",
  "issue.short.handle": "Отсутствует адрес",
  "issue.short.readingTime": "Более 60 с",
  "issue.short.readingTimeLong": "Более 30 с",
  "issue.short.readingTimeShort": "Слишком мало контента",
  "issue.short.bodyPlaceholder": "Пример содержимого в тексте",
  "issue.short.bodyFormat": "Формат текста",
  "issue.short.links": "Проблема с ссылкой",
  "issue.short.linksEmpty": "Ссылки можно добавлять",
  "issue.short.pending": "Нужна работа",
  "issue.summary.more": "{count} элементы, которые нужно исправить",
  "publish.title.create": "Подтвердить публикацию",
  "publish.title.update": "Подтвердить изменения",
  "publish.action.create": "Опубликовать в 30s.to",
  "publish.action.update": "Опубликовать изменения",
  "publish.closeAria": "Закрыть подтверждение публикации",
  "publish.address": "Публичное обращение",
  "publish.unpublishedChanges": "Неопубликованные изменения",
  "publish.handleChanged": "Адрес изменится с @{oldHandle} на @{newHandle}. Старый адрес будет перенаправлять посетителей 30 дней. Через 180 дней после смены его могут передать другому человеку, и старые ссылки могут показывать его профиль.",
  "publish.readingTime": "Время чтения",
  "publish.status": "Статус",
  "publish.ready": "Готовый",
  "publish.todo": "{count} предметы для улучшения",
  "publish.visibility": "Способ публикации",
  "publish.visibility.indexed": "Разрешить поисковую индексацию",
  "publish.visibility.unlisted": "Доступ по ссылке",
  "publish.visibility.indexedNote": "Страница доступна всем и может появиться в результатах поиска.",
  "publish.visibility.unlistedNote": "Страница доступна всем, у кого есть ссылка; мы не отправляем её поисковым системам.",
  "publish.visibility.publicNote": "Оба варианта общедоступны, а ссылку можно переслать. Оставьте черновик, если страницу должны видеть только вы.",
  "publish.publicContent": "После публикации имя, описание, теги, текст и ссылки станут общедоступными. Авторские комментарии скрыты, но не должны содержать секреты.",
  "publish.noop": "Публичная страница уже обновлена. Измените контент или видимость перед повторной публикацией.",
  "publish.valid": "Контент проходит проверку публикации.",
  "handleEdit.title": "Изменить публичный адрес",
  "handleEdit.label": "30s.to адрес",
  "handleEdit.help.changed": "Сохранение меняет только черновик. После публикации старый адрес будет перенаправлять посетителей 30 дней; через 180 дней его могут передать другому человеку.",
  "handleEdit.help.saved": "Сохранено в черновик. Доступность проверяется еще раз при публикации.",
  "handleEdit.note": "Текущий публичный адрес по-прежнему 30s.to/@{handle}. Новый адрес вступит в силу после публикации.",
  "handleEdit.save": "Сохранить в черновик",
  "conflict.title": "Выбрать черновую версию",
  "conflict.copy": "На этом устройстве и в облаке есть неопубликованный контент. Ваш выбор станет следующей версией для редактирования.",
  "conflict.useLocal": "Использовать локальный черновик",
  "conflict.useLocalCopy": "Сохраните текущее содержимое страницы и синхронизируйте его с облаком.",
  "conflict.useCloud": "Использовать облачный черновик",
  "conflict.untitled": "Без названия",
  "conflict.cloudVersion": "Версия сохранена в облаке",
  "conflict.modifiedAt": "Последнее изменение · {time}",
  "conflict.time.justNow": "только что",
  "conflict.time.minutesAgo": "{count} мин назад",
  "conflict.time.hoursAgo": "{count} ч назад",
  "conflict.time.daysAgo": "{count} дн. назад",
  "authModal.title": "Войдите в 30s.to",
  "authModal.copy": "После входа в систему черновики синхронизируются с облаком, и публикация становится более надежной.",
  "login.page.eyebrow": "Счет",
  "login.page.title": "Войдите в 30s.to",
  "login.page.copy": "Синхронизируйте черновики, публикуйте общедоступные страницы и управляйте приглашениями.",
  "login.invalidEmail": "Введите действительный адрес электронной почты.",
  "login.sendFailed": "Не удалось отправить код.",
  "login.devCodeReady": "Создан локальный код разработки.",
  "login.codeSent": "Код отправлен. Проверьте свою электронную почту.",
  "login.networkSendFailed": "Не удалось отправить код. Проверьте свое соединение.",
  "login.invalidCode": "Введите 6-значный код.",
  "login.codeInvalid": "Код неправильный или срок его действия истек.",
  "login.failed": "Ошибка входа. Повторите попытку позже.",
  "login.sendBusy": "Отправка...",
  "login.resendCode": "Отправить код повторно",
  "login.sendCode": "Отправить код",
  "login.localCode": "Локальный код разработки: {code}.",
  "login.code": "Код",
  "login.codePlaceholder": "6 цифр",
  "login.inviteHelp": "Для публичной бета-версии требуется код приглашения. Проверка активирует вашу учетную запись.",
  "login.verifyBusy": "Проверка...",
  "login.verifyInvite": "Подтвердите приглашение и войдите в систему",
  "login.verify": "Войти и продолжить",
  "login.footnote": "Беспарольный вход. Новые пользователи активируются с помощью приглашения после проверки электронной почты.",
  "login.google": "Продолжить с Google",
  "login.github": "Продолжить с GitHub",
  "login.emailDivider": "или используйте электронную почту",
  "login.oauthFailed": "Вход через социальную сеть не завершен. Попробуйте еще раз или используйте вход по электронной почте.",
  "login.linkTitle": "Подтвердите адрес электронной почты аккаунта",
  "login.linkPageCopy": "Учетная запись 30s.to уже использует этот адрес электронной почты. Мы привязываем его только после проверки; учетные записи никогда не объединяются автоматически.",
  "login.linkCopy": "Мы отправим код на {email}. Электронную почту здесь изменить нельзя.",
  "login.linkVerify": "Подтвердить и связать",
  "login.linkRequired": "Обнаружен существующий аккаунт. Подтвердите адрес электронной почты, чтобы продолжить.",
  "login.activateTitle": "Активировать 30s.to",
  "login.activatePageCopy": "Ваша социальная идентичность подтверждена. Постоянная учетная запись не создается до тех пор, пока приглашение не будет успешным.",
  "login.activateCopy": "Публичная бета-версия требует приглашения. Он активируется только в случае успешного создания учетной записи.",
  "login.activationOpenCopy": "Регистрация открыта. Продолжите, чтобы активировать учетную запись.",
  "login.activationClosedCopy": "Активация новых учетных записей приостановлена. Существующие учетные записи по-прежнему могут входить.",
  "login.activate": "Активировать и продолжить",
  "login.inviteRequired": "Email проверено. Используйте приглашение для активации.",
  "login.useEmailInstead": "Вместо этого используйте вход по электронной почте",
  "preview.emptyEyebrow": "Предварительный просмотр",
  "preview.emptyTitle": "Вступление недоступно для предварительного просмотра.",
  "preview.backToEdit": "Вернуться к редактированию",
  "preview.edit": "Редактировать",
  "preview.localNoteAria": "Примечание о локальном предварительном просмотре",
  "preview.localNote": "Местное признание",
  "preview.localTitle": "Предварительный просмотр черновика на этом устройстве",
  "preview.themePicker": "Переключатель тем",
  "preview.themeGroup": "Выбрать тему",
  "preview.themeFree": "База",
  "preview.themePro": "Про",
  "preview.mobileAria": "Предварительный просмотр общедоступной мобильной страницы",
  "preview.close": "Закрыть предварительный просмотр",
  "preview.editorTitle": "Предварительный просмотр",
  "preview.publicTitle": "Предварительный просмотр общедоступной страницы",
  "preview.shareCardButton": "Посмотреть карточку темы",
  "preview.shareCardDialogTitle": "Предварительный просмотр карточки темы",
  "preview.shareCardTitle": "Карточка темы {theme}",
  "preview.shareCardLogin": "Войдите, чтобы сделать реальный предварительный просмотр",
  "preview.shareCardLoading": "Отображение тематической карточки…",
  "preview.shareCardError": "Предварительный просмотр карты временно недоступен.",
  "preview.shareCardNote": "Карточка темы использует тот же визуальный язык, что и общедоступная страница. Универсальные карты доступны в Dashboard.",
  "public.copySuccess": "Скопировано {label}",
  "public.copyFailed": "Копировать не удалось. Пожалуйста, скопируйте вручную.",
  "public.createMine": "Создать мое вступление",
  "public.report": "Пожаловаться на эту страницу",
  "public.ownerAria": "Вход в личный кабинет",
  "public.owner.manage": "Управлять",
  "public.owner.edit": "Редактировать",
  "public.status.unavailable": "Недоступно",
  "public.status.notFound": "404",
  "public.status.moderated": "Это 30-секундное вступление недоступно.",
  "public.status.frozen": "Этот публичный адрес недоступен.",
  "public.status.unpublished": "Это 30-секундное вступление еще не опубликовано.",
  "theme.footer": "Сделано с помощью 30s.to",
  "theme.fallback.name": "Ваше имя",
  "theme.fallback.nameUpper": "ВАШЕ ИМЯ",
  "theme.fallback.nameNoir": "Имя",
  "theme.fallback.nameIndex": "Джон Доу",
  "theme.fallback.identity": "Что вы делаете?",
  "theme.fallback.identityUpper": "ВАША ИДЕНТИЧНОСТЬ И МИССИЯ ONE LINE",
  "theme.fallback.identityIndex": "Неизвестный",
  "theme.fallback.identityNoir": "Личность",
  "theme.fallback.terminalName": "гость",
  "theme.fallback.terminalIntro": "Пока нет короткого вступления",
  "theme.terminal.commandLabel": "Команда терминала",
  "theme.terminal.commandSubmit": "Команда запуска",
  "theme.terminal.outputLabel": "Интерактивный вывод терминала",
  "theme.connect": "СОЕДИНЯТЬ",
  "theme.markdown.tableRegion": "Таблица содержимого с горизонтальной прокруткой",
  "theme.markdown.task": "Задача",
  "theme.tags": "ТЕГИ",
  "theme.verified": "ПРОВЕРЕНО",
  "theme.name": "ИМЯ",
  "theme.identityLabel": "ЛИЧНОСТЬ",
  "theme.keywords": "КЛЮЧЕВЫЕ СЛОВА",
  "theme.scroll": "Прокрутка",
  "theme.pixel.previous": "Предыдущий экран",
  "theme.pixel.next": "Следующий экран",
  "theme.pixel.screen": "Экран {current} из {total}",
  "theme.arcade.stage": "Этап {current} / {total}",
  "theme.noise.reseed": "Повторный шум",
  "theme.readingTime": "{seconds} с чтения",
  "theme.readingUnit": "с чтения",
  "theme.letter.greeting": "Здравствуйте,",
  "theme.letter.signoff": "С уважением,",
  "theme.letter.postscript": "Где меня найти",
  "theme.letter.written": "Написано {date}",
  "dashboard.loginTitle": "Войдите, чтобы управлять своим вступлением.",
  "dashboard.loginAction": "Войдите и управляйте",
  "dashboard.bannedTitle": "Эта учетная запись в настоящее время недоступна.",
  "dashboard.bannedCopy": "Если вы считаете, что это ошибка, свяжитесь с нами, отправив отчет и подав апелляцию.",
  "connections.kicker": "Счет",
  "connections.title": "Способы входа",
  "connections.settingsKicker": "Настройки",
  "connections.settingsTitle": "Аккаунт и подключения",
  "connections.settingsCopy": "Управляйте способами входа и доступом сторонних Agent.",
  "connections.backToDashboard": "Назад в панель управления",
  "connections.emailCode": "Код подтверждения по почте",
  "connections.alwaysAvailable": "Всегда доступно",
  "connections.connect": "Соединять",
  "connections.disconnect": "Удалить ссылку 30s.to",
  "connections.notConnected": "Не подключено",
  "connections.noEmail": "Электронная почта не указана",
  "connections.emailVerified": "Email проверено",
  "connections.connected": "Подключено",
  "connections.unavailable": "Не включено",
  "connections.confirm": "Удалить ссылку {provider} из 30s.to? Логин Email остается доступным.",
  "connections.removed": "Идентификационная ссылка была удалена из 30s.to.",
  "connections.failed": "Не удалось обновить методы входа. Повторите попытку позже.",
  "connections.help": "При этом удаляется только сопоставление идентификаторов 30s.to; он не отменяет доступ провайдера. Управление доступом провайдера:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Подключения Agent",
  "agentConnections.copy": "Установите один Skill, чтобы привычные Agents собирали сведения, готовили текст и безопасно обновляли черновик 30s.to.",
  "agentConnections.addTitle": "Подключить нового Agent",
  "agentConnections.addCopy": "Посмотреть адрес подключения и шаги настройки",
  "agentConnections.examplesDisclosure": "Посмотреть примеры использования",
  "settings.title": "Настройки",
  "settings.copy": "Управляйте аккаунтом, безопасностью, внешними подключениями и тарифом 30s.to.",
  "settings.navAria": "Разделы настроек",
  "settings.account.title": "Аккаунт",
  "settings.account.copy": "Ваша учётная запись 30s.to и доступ к профилю.",
  "settings.account.email": "Почта аккаунта",
  "settings.account.profile": "Профиль",
  "settings.account.plan": "Текущий тариф",
  "settings.account.manageProfile": "Управлять профилем",
  "settings.login.copy": "Управляйте способами входа в 30s.to.",
  "settings.billing.copy": "Проверьте текущий тариф, продление и доступ к оплате.",
  "settings.invites.copy": "Управляйте лимитом приглашений Public Beta и недавними кодами.",
  "agentConnections.endpoint": "URL подключения",
  "agentConnections.copyAction": "Копировать",
  "agentConnections.copied": "Скопировано",
  "agentConnections.copyFailed": "Не удалось скопировать. Скопируйте URL вручную.",
  "agentConnections.endpointCopied": "URL подключения скопирован.",
  "agentConnections.stepsAria": "Как подключить Agent",
  "agentConnections.step1": "Добавьте удалённый сервис в настройках MCP или коннекторов вашего Agent.",
  "agentConnections.step2": "Вставьте URL подключения, войдите в 30s.to и разрешите доступ.",
  "agentConnections.step3": "Скажите Agent, что нужно изменить, затем вернитесь в 30s.to и проверьте черновик.",
  "agentConnections.examplesTitle": "Примеры запросов",
  "agentConnections.exampleFirst": "Прочитай мой профиль 30s.to и правила форматирования и помоги завершить моё первое представление.",
  "agentConnections.exampleSection": "Сохрани мой стиль и перепиши только раздел «Сейчас».",
  "agentConnections.exampleShorten": "Сократи весь текст так, чтобы он читался меньше 30 секунд. Не публикуй его.",
  "agentConnections.copyExample": "Копировать пример {number}",
  "agentConnections.promptCopied": "Пример запроса скопирован.",
  "agentConnections.boundary": "Agents могут только читать и обновлять черновики. Они не могут публиковать или прекращать публикацию за вас.",
  "agentConnections.authorizedTitle": "Авторизованные подключения",
  "agentConnections.empty": "Подключения Agent ещё не авторизованы.",
  "agentConnections.disabled": "Подключения Agent пока не включены.",
  "agentConnections.scopeRead": "Чтение черновика",
  "agentConnections.scopeWrite": "Изменение черновика",
  "agentConnections.connectedAt": "Подключено {date}",
  "agentConnections.selfReported": "Название клиента указано самим клиентом",
  "agentConnections.revoke": "Отозвать",
  "agentConnections.confirm": "Отозвать подключение к {client}? Этот клиент больше не сможет обращаться к вашему черновику 30s.to.",
  "agentConnections.confirmSkill": "Отозвать подключение 30s.to Skill? Локальные Agents, использующие этот Skill, выйдут из 30s.to.",
  "agentConnections.revoked": "Подключение Agent отозвано.",
  "agentConnections.failed": "Не удалось обновить подключения Agent. Повторите попытку позже.",
  "agentConnections.manualTitle": "Подключить Remote MCP вручную",
  "agentConnections.manualCopy": "Расширенный вариант: отдельно авторизуйте клиент с поддержкой Remote MCP",
  "skill.meta.title": "30s.to Skill — Пусть Agent напишет ваше представление",
  "skill.meta.description": "Пришлите сайт, проекты или портфолио. Agent изучит ваши работы и проведёт интервью, чтобы написать ваше представление на 30 секунд.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "Расскажите о себе\nс помощью агента.",
  "skill.copy": "Дайте ему несколько ссылок. Агент изучит ваши работы и поможет написать рассказ о себе на 30 секунд чтения.",
  "skill.processTitle": "Как Agent помогает написать текст",
  "skill.process.clues.title": "Пришлите ссылки",
  "skill.process.clues.copy": "Открытый профиль, сайт проекта или портфолио.",
  "skill.process.research.title": "Подробное изучение, затем интервью",
  "skill.process.research.copy": "Агент подробно изучает ваш сайт, проекты и работы, выделяет главное, а затем проводит интервью, чтобы дополнить то, чего нет в материалах.",
  "skill.process.profile.title": "Agent пишет о вас",
  "skill.process.profile.copy": "Вместе уточните содержание и тон, чтобы представление звучало по-вашему.",
  "skill.installTitle": "Установите в свой Agent",
  "skill.installCopy": "Скопируйте инструкцию, вставьте её в привычный агент и отправьте.",
  "skill.promptLabel": "Инструкция по установке",
  "skill.copyPrompt": "Скопировать инструкцию по установке",
  "skill.promptCopied": "Инструкция по установке скопирована. Теперь откройте Agent, которым пользуетесь, вставьте инструкцию и отправьте её.",
  "skill.copyFailed": "Не удалось скопировать. Выделите и скопируйте инструкцию ниже.",
  "skill.startTitle": "Как начать",
  "skill.start.install": "Установите 30s.to Skill",
  "skill.start.chat": "Начните беседу",
  "skill.start.chatCopy": "После установки откройте новый диалог и напишите:",
  "skill.start.prompt": "Помоги написать рассказ обо мне с помощью 30s.to.",
  "dashboard.kicker": "Мое вступление",
  "dashboard.defaultTitle": "Мое 30-секундное вступление",
  "dashboard.primaryEdit": "Продолжить редактирование",
  "dashboard.primaryCreate": "Начните создавать",
  "dashboard.unpublished": "Не опубликовано",
  "dashboard.unselected": "Не выбрано",
  "dashboard.confirmDiscard": "Отменить неопубликованные изменения и восстановить текущую общедоступную версию?",
  "dashboard.discardFailed": "Не удалось отменить изменения.",
  "dashboard.discardConflict": "Этот черновик был изменён в другом месте. Обновите страницу и проверьте его перед повторной попыткой.",
  "dashboard.discardNetworkFailed": "Не удалось отменить изменения. Повторите попытку позже.",
  "dashboard.discardDone": "Восстановлена ​​до текущей общедоступной версии.",
  "dashboard.statusAria": "Текущий статус",
  "dashboard.versionAria": "Связь версий",
  "dashboard.publicPage": "Публичная страница",
  "dashboard.indexingAllowed": "Индексация разрешена",
  "dashboard.indexingBlocked": "Доступ по ссылке",
  "dashboard.publicVersion": "Опубликованная версия",
  "dashboard.invisible": "Пока не виден другим",
  "dashboard.draft": "Черновик",
  "dashboard.currentDraft": "Текущая редактируемая версия",
  "dashboard.draftSynced": "Синхронизировано с общедоступной страницей",
  "dashboard.editableVersionEmpty": "Редактируемая версия · Не создано",
  "dashboard.editableVersionDirty": "Редактируемая версия · Изменения не опубликованы",
  "dashboard.editableVersionSynced": "Редактируемая версия · Соответствует общедоступной странице.",
  "dashboard.editableVersionUnpublished": "Редактируемая версия · Не опубликовано",
  "dashboard.betaActive": "Активный",
  "dashboard.betaInactive": "Неактивный",
  "dashboard.adminCanPublish": "Учетная запись администратора может публиковать",
  "dashboard.betaAccessNote": "Доступ к публикации публичной бета-версии",
  "dashboard.visibility": "Видимость",
  "dashboard.chooseOnPublish": "Выберите во время подтверждения публикации",
  "dashboard.snapshot": "Снимок",
  "dashboard.snapshotAfterPublish": "Снимок общедоступной страницы создается после публикации.",
  "dashboard.publishDetailsAria": "Подробности публикации",
  "dashboard.actionsAria": "Действия руководства",
  "dashboard.nextAction": "Следующий шаг",
  "dashboard.openPublicPage": "Открыть общедоступную страницу",
  "dashboard.changeVisibility": "Изменить способ публикации",
  "dashboard.unpublish": "Остановить публикацию",
  "dashboard.unpublishTitle": "Остановить публикацию?",
  "dashboard.unpublishDescription": "Общедоступная страница сразу станет недоступна. Черновик и публичный адрес сохранятся, чтобы вы могли опубликовать её снова.",
  "dashboard.unpublishWarning": "Копии, уже сохранённые поисковыми системами или другими людьми, могут исчезнуть не сразу.",
  "dashboard.unpublishConfirm": "Остановить публикацию",
  "dashboard.unpublishBusy": "Останавливаем...",
  "dashboard.unpublishSuccess": "Общедоступная страница больше недоступна. Черновик и публичный адрес сохранены.",
  "dashboard.unpublishFailed": "Не удалось остановить публикацию. Повторите попытку позже.",
  "dashboard.discardBusy": "Восстановление...",
  "dashboard.discard": "Отменить изменения",
  "dashboard.metricsAria": "Легкие данные",
  "dashboard.views": "Просмотры",
  "dashboard.clicks": "Клики",
  "dashboard.readingTime": "Время чтения",
  "dashboard.theme": "Тема",
  "dashboard.noTheme": "Не выбрано",
  "dashboard.visibility.indexed": "Разрешить поисковую индексацию",
  "dashboard.visibility.unlisted": "Доступ по ссылке",
  "dashboard.visibility.indexedNote": "Может появиться в результатах поиска",
  "dashboard.visibility.unlistedNote": "Остаётся доступной всем, у кого есть прямая ссылка",
  "dashboard.snapshot.ready": "Кэш готов",
  "dashboard.snapshot.failed": "Резервный вариант D1",
  "dashboard.snapshot.none": "Не создано",
  "dashboard.snapshot.readyNote": "Публичный снимок, отправленный в KV",
  "dashboard.snapshot.failedNote": "Публичная страница по-прежнему работает через резервный вариант D1",
  "dashboard.snapshot.noneNote": "Для текущей опубликованной версии моментальный снимок не доступен.",
  "invite.title": "Пригласите друзей в публичное бета-тестирование",
  "invite.remaining": "Приглашения на {remaining} / {quota} остались в этом месяце.",
  "invite.generateFailed": "Не удалось создать приглашение.",
  "invite.generated": "Создано кодов приглашения: {count}. Они показываются только сейчас.",
  "invite.quotaUsed": "Использована месячная квота приглашений.",
  "invite.generating": "Создание...",
  "invite.generate": "Создать все оставшиеся: {count}",
  "invite.batchTitle": "Создано кодов: {count}",
  "invite.copyAll": "Копировать все коды",
  "invite.copiedAll": "Все коды скопированы",
  "invite.copyMessage": "Копировать текст",
  "invite.messageCopied": "Текст скопирован",
  "invite.share": "Поделиться",
  "invite.shared": "Открыто меню «Поделиться».",
  "invite.shareFallback": "Прямой доступ недоступен, поэтому текст был скопирован.",
  "invite.shareFailed": "Не удалось поделиться. Скопируйте текст.",
  "invite.shareMessage": "Я использую 30s.to, чтобы создать 30-секундное представление о себе. Попробуйте и вы.\n\nКоды приглашения:\n{codes}\n\nОткройте {url}, чтобы начать.",
  "invite.recentAria": "Статус использования приглашений",
  "invite.statusTitle": "Статус использования",
  "invite.statusSummary": "Доступно: {active} · использовано: {redeemed} · истекло: {expired} · отозвано: {revoked}",
  "invite.status.revoked": "Отозван",
  "invite.status.redeemed": "Использовал",
  "invite.status.expired": "Истекший",
  "invite.status.active": "Доступный",
  "invite.copy": "Копировать",
  "invite.copied": "Скопировано",
  "invite.showOnce": "Показано только один раз",
  "invite.expiryUnknown": "Срок действия неизвестен",
  "invite.expiresAt": "Срок действия истекает {date}",
  "management.handlePending.title": "Ожидается изменение адреса",
  "management.handlePending.description": "Текущий публичный адрес по-прежнему {publishedAddress}. Публикация активирует {draftAddress}.",
  "management.handlePending.next": "Публикуйте изменения до того, как {draftAddress} станет публичным адресом.",
  "management.dirty.title": "Неопубликованные изменения",
  "management.dirty.description": "Ваш черновик не был опубликован на общедоступной странице.",
  "management.dirty.next": "Опубликуйте изменения, чтобы синхронизировать общедоступную страницу с этим черновиком.",
  "management.published.title": "Опубликовано",
  "management.published.description": "Публичная страница обновлена.",
  "management.published.next": "Публичная страница синхронизируется. Продолжайте редактирование, если хотите его настроить.",
  "management.unpublished.title": "Неопубликовано",
  "management.unpublished.description": "Это вступление все еще сохраняется только как черновик.",
  "management.unpublished.next": "Опубликуйте его до того, как другие смогут посетить публичный адрес.",
  "management.empty.title": "Пока нет вступления",
  "management.empty.description": "Выберите адрес и напишите 30-секундное вступление.",
  "management.empty.next": "Сначала создайте черновик. Проверки перед публикацией остаются в редакторе.",
  "management.publish.create": "Опубликовать вступление",
  "management.publish.update": "Опубликовать изменения",
  "abuse.kicker": "Доверие и безопасность",
  "abuse.title": "Страница отчета",
  "abuse.copy": "Отчеты используются только для проверки безопасности. Ваша личность не разглашается.",
  "abuse.missingHandle": "Отсутствует цель отчета.",
  "abuse.done": "Отчет получен. Мы рассмотрим его в ближайшее время.",
  "abuse.failed": "Отправка не удалась. Повторите попытку позже.",
  "abuse.reason.spam": "Спам",
  "abuse.reason.impersonation": "Олицетворение",
  "abuse.reason.abuse": "Преследование или ненависть",
  "abuse.reason.illegal": "Незаконный контент",
  "abuse.reason.other": "Другая проблема",
  "abuse.submitBusy": "Отправка...",
  "abuse.submit": "Отправить отчет",
  "terms.title": "Условия использования",
  "privacy.title": "Уведомление о конфиденциальности",
  "validation.handle.required": "Введите дескриптор.",
  "validation.handle.invalid": "В дескрипторе должно быть от 4 до 24 строчных английских букв.",
  "validation.handle.reserved": "Этот публичный адрес недоступен. Попробуйте другой.",
  "validation.handle.unavailable": "Этот публичный адрес недоступен. Попробуйте другой.",
  "validation.handle.frozen": "Этот публичный адрес недоступен. Попробуйте другой.",
  "validation.handle.protected": "Этот публичный адрес недоступен. Попробуйте другой.",
  "validation.handle.checkFailed": "Нам не удалось подтвердить этот адрес.",
  "validation.handle.changeLimit": "Вы можете изменить свой публичный адрес только один раз каждые 30 дней.",
  "validation.displayName.required": "Требуется имя или псевдоним.",
  "validation.identity.required": "Требуется однострочный идентификатор.",
  "validation.tags.range": "Добавьте 1–5 тегов.",
  "validation.links.limit": "Вы можете добавить до {limit} отдельных ссылок.",
  "validation.links.empty": "Ссылок пока нет. Вы можете добавить профиль в социальной сети, страницу бронирования или способ связи.",
  "validation.input.tooLong": "Текст может содержать не более {limit} символов.",
  "validation.body.placeholder": "В тексте всё ещё есть {detail}. Замените этот фрагмент реальным содержанием или удалите.",
  "validation.body.oldTemplate": "прежний шаблон текста",
  "validation.body.readingTime": "Расчётное время чтения — {seconds} секунд. Сократите текст до {maximum} секунд.",
  "validation.body.readingTimeLong": "Расчётное время чтения — {seconds} секунд, что превышает рекомендуемый предел в {recommended} секунд, но публикация всё ещё доступна.",
  "validation.body.readingTimeShort": "Расчётное время чтения — {seconds} секунд. Добавьте содержание хотя бы до {minimum} секунд.",
  "validation.markdown.h1": "# заголовки на уровне страницы не поддерживаются",
  "validation.markdown.deepHeading": "### и более глубокие заголовки не поддерживаются.",
  "validation.markdown.image": "Синтаксис изображения не поддерживается.",
  "validation.markdown.codeBlock": "Блоки кода не поддерживаются",
  "validation.markdown.taskList": "Списки задач не поддерживаются",
  "validation.markdown.table": "Таблицы не поддерживаются",
  "validation.markdown.footnote": "Сноски не поддерживаются",
  "validation.markdown.html": "HTML и встраивания не поддерживаются.",
  "validation.markdown.commentUnclosed": "У комментария нет закрывающего маркера -->",
  "validation.markdown.commentStrayClose": "У комментария нет открывающего маркера <!--",
  "validation.markdown.commentNested": "Вложенные комментарии <!-- --> не поддерживаются",
  "validation.markdown.nestedHeading": "Заголовки разделов должны находиться на корневом уровне документа",
  "validation.markdown.setextHeading": "Заголовки Setext не поддерживаются",
  "validation.markdown.headingInline": "Заголовки разделов могут содержать только обычный текст",
  "validation.markdown.frontmatter": "Frontmatter не поддерживается",
  "validation.markdown.indentedCode": "Блоки кода с отступом не поддерживаются; используйте ограждённый блок",
  "validation.markdown.codeFenceUnclosed": "Отсутствует закрывающий маркер блока кода",
  "validation.markdown.codeLanguage": "Тег языка допускает 1–32 буквы, цифры, _, + или -",
  "validation.markdown.listDepth": "Списки поддерживают до трёх уровней",
  "validation.markdown.tableSize": "Таблицы поддерживают до 6 столбцов и 20 строк",
  "validation.markdown.linkProtocol": "Ссылки в тексте поддерживают только HTTPS и электронную почту",
  "validation.link.unsupportedType": "Этот тип ссылки пока не поддерживается. Выберите ссылку на сайт, платформу или страницу записи.",
  "validation.link.labelRequired": "Имя ссылки не может быть пустым.",
  "validation.link.providerRequired": "Выберите платформу бронирования.",
  "validation.link.valueRequired": "{label} не может быть пустым.",
  "validation.link.httpsOnly": "Ссылки поддерживают только https://.",
  "validation.link.invalid": "Введите действительную ссылку.",
  "validation.link.validEmail": "Введите действительный адрес электронной почты.",
  "validation.link.validGithub": "Введите действительный дескриптор GitHub.",
  "validation.link.validBilibili": "Введите действительный Bilibili UID.",
  "validation.link.validXiaohongshu": "Введите действительную ссылку на профиль Xiaohongshu.",
  "validation.link.validGoogleCalendar": "Введите действительную ссылку для бронирования Google Calendar.",
  "validation.link.validMicrosoftBookings": "Введите действительную ссылку Microsoft Bookings.",
  "validation.theme.proRequired": "Для публикации этой темы требуется 30s Pro.",
  "validation.link.validHubSpot": "Введите действительную ссылку HubSpot Meetings.",
  "validation.account.banned": "Этот аккаунт не может публиковать прямо сейчас.",
  "validation.account.login": "Пожалуйста, сначала войдите в систему.",
  "validation.account.invite": "Сначала активируйте свою учетную запись с помощью пригласительного кода.",
  "validation.publish.failed": "Публикация не удалась. Повторите попытку позже.",
  "validation.turnstile.required": "Пройдите проверку безопасности.",
  "validation.report.missing": "Не указана страница для жалобы.",
  "validation.report.reason": "Выберите причину жалобы.",
  "validation.report.notReportable": "Сейчас невозможно сообщить об этой странице.",
  "common.listSeparator": ",",
  "dashboard.section.status": "Статус",
  "dashboard.section.performance": "Производительность",
  "dashboard.fullAnalytics": "Посмотреть полную аналитику",
  "dashboard.shareCard": "Поделиться картой",
  "dashboard.timestamp.notPublished": "Не опубликовано",
  "dashboard.timestamp.notEdited": "Не редактировалось",
  "dashboard.timestamp.published": "Опубликовано {date} UTC",
  "dashboard.timestamp.edited": "Отредактировано {date} UTC.",
  "upgrade.publishTheme": "Опубликовать {theme}",
  "upgrade.copy": "Выбор сохранён, и полный предпросмотр остаётся доступен. После перехода на Pro страницу можно опубликовать без повторного редактирования.",
  "upgrade.benefit.themes": "Публикуйте каждую премиум-тему",
  "upgrade.benefit.analytics": "Посмотрите время чтения и завершение",
  "upgrade.benefit.cards": "Тематические карточки синхронизируются с социальной сетью OG.",
  "upgrade.seePro": "См. 30s Pro",
  "upgrade.keepEditing": "Продолжайте редактировать",
  "pro.meta.title": "30s Pro — Выразите себя",
  "pro.meta.description": "Премиум-темы, аналитика чтения и карточки для публикации делают вашу 30-секундную визитку по-настоящему личной.",
  "pro.title": "Выразите себя ярче.",
  "pro.intro": "По-прежнему 30 секунд на чтение. Pro дает больше свободы в оформлении, понятнее показывает реакцию и готовит материалы для публикации.",
  "pro.priceAction": "Посмотреть Founding Price",
  "pro.summaryAria": "Обзор преимуществ Pro",
  "pro.summaryThemes": "премиум-темы",
  "pro.summaryAnalytics": "дней аналитики",
  "pro.summaryShare": "связано с карточкой",
  "pro.benefitsKicker": "Возможности Pro",
  "pro.benefitsTitle": "От самовыражения к вниманию.",
  "pro.benefit.themes.title": "Премиум-темы",
  "pro.benefit.themes.body": "Восемь тем, включая Terminal. Все можно бесплатно примерить, а с Pro — опубликовать выбранную.",
  "pro.benefit.analytics.title": "Качество чтения",
  "pro.benefit.analytics.body": "Выходите за рамки посещений, отслеживая время активного чтения, процент завершения, распределение прогресса, тенденции за 30, 90 и 365 дней, а также рейтинг кликов по ссылкам.",
  "pro.benefit.share.title": "Делитесь в своем стиле",
  "pro.benefit.share.body": "В Free есть одна простая карточка с именем и ссылкой. Pro добавляет две универсальные карты и один дизайн для каждой темы. Ваш выбор становится изображением OG со встроенным QR-кодом для обмена и загрузки.",
  "pro.benefit.attribution.title": "Только вы",
  "pro.benefit.attribution.body": "Скройте подпись 30s.to внутри темы, сохранив необходимые функции жалобы и выбора языка.",
  "pro.pricingTitle": "Чем раньше вы с нами, тем проще.",
  "pro.pricingBody": "Founding Price сохраняется, пока действует подписка. После ее прекращения новая подписка оформляется по актуальной цене.",
  "pro.terminalAria": "Предварительный просмотр темы Terminal Pro",
  "pro.checkout.continuous": "Цена сохраняется при непрерывной подписке",
  "pro.checkout.intervalAria": "Платежный интервал",
  "pro.checkout.monthly": "Ежемесячно",
  "pro.checkout.yearly": "Ежегодно",
  "pro.checkout.save": "Сэкономьте 16 долларов США",
  "pro.checkout.periodYear": "год",
  "pro.checkout.periodMonth": "месяц",
  "pro.checkout.annualNote": "В пересчете ${price} в месяц — на 44 % дешевле ежемесячной оплаты.",
  "pro.checkout.monthlyNote": "Платите помесячно и отменяйте к концу любого периода.",
  "pro.checkout.includeThemes": "Все премиум-темы",
  "pro.checkout.includeAnalytics": "Качество чтения и 365-дневная аналитика",
  "pro.checkout.includeCards": "Тематические карточки, QR и OG",
  "pro.checkout.includeAttribution": "Скрыть атрибуцию в теме",
  "pro.checkout.manage": "Управлять подпиской Pro",
  "pro.checkout.comingSoon": "Оплата скоро откроется",
  "pro.checkout.signIn": "Войти и перейти на Pro",
  "pro.checkout.inviteRequired": "Требуется приглашение на бета-тестирование",
  "pro.checkout.opening": "Открытие безопасной оплаты…",
  "pro.checkout.upgrade": "Перейти на 30s Pro",
  "pro.checkout.footnote": "Безопасная оплата через Creem. Налоги видны до платежа; пробного периода нет, подписка продлевается автоматически.",
  "pro.checkout.unavailable": "Сейчас не удается открыть оплату. Повторите попытку позже.",
  "pro.checkout.networkError": "Не удалось подключиться. Повторите попытку позже.",
  "billing.panelAria": "Pro и платежи",
  "billing.plan": "Тариф",
  "billing.status.canceling": "Отмена запланирована",
  "billing.status.pastDue": "Просроченный платеж",
  "billing.status.active": "Активный",
  "billing.status.free": "Бесплатно",
  "billing.yearly": "Ежегодно",
  "billing.monthly": "Ежемесячно",
  "billing.basicPlan": "Базовый план",
  "billing.ends": "Заканчивается {date}",
  "billing.renews": "Продление: {date}",
  "billing.graceEnds": "Льготный период заканчивается: {date}",
  "billing.anomaly": "Платежный статус нужно проверить вручную. Напишите на support@30s.to.",
  "billing.opening": "Открываем управление оплатой",
  "billing.manage": "Управление оплатой",
  "billing.upgrade": "Обновите до Pro",
  "billing.openingHistory": "Открываем историю платежей…",
  "billing.viewHistory": "Посмотреть историю платежей",
  "billing.portalUnavailable": "Управление платежами временно недоступно.",
  "billing.networkError": "Сетевое соединение не удалось. Пожалуйста, попробуйте еще раз.",
  "billingReturn.kicker": "30s Pro · Проверка платежа",
  "billingReturn.activeTitle": "Pro подключён",
  "billingReturn.failedTitle": "Оплата еще не подтверждена",
  "billingReturn.waitingTitle": "Подтверждение вашего платежа",
  "billingReturn.failedCopy": "Возможно, ваш платеж все еще синхронизируется. Проверьте панель управления позже; доступ никогда не предоставляется только с обратной страницы.",
  "billingReturn.waitingCopy": "Мы проверяем вашу подписку у платежного провайдера. Держите эту страницу открытой.",
  "billingReturn.back": "Вернуться в панель управления",
  "analytics.kicker": "30s Pro · Аналитика",
  "analytics.nav": "Аналитика",
  "analytics.title": "От посещения до полного прочтения.",
  "analytics.copy": "Смотрите путь от посещения до полного прочтения и переходов по ссылкам, не отслеживая людей. Даты и дедупликация рассчитываются по UTC.",
  "analytics.rangeAria": "Диапазон дат",
  "analytics.days": "{count} дней",
  "analytics.uniqueVisitors": "Уникальные посетители",
  "analytics.rangeTotal": "Итого за {count} дней",
  "analytics.averageReading": "Среднее активное время чтения",
  "analytics.activeReadingNote": "Время, когда страница была видна и активна",
  "analytics.completionRate": "Доля дочитываний",
  "analytics.completedVisitors": "{count} посетителей дочитали до конца",
  "analytics.overallCtr": "Общий CTR",
  "analytics.engagedVisitors": "{count} посетителей взаимодействовали",
  "analytics.trafficTrend": "Тенденция трафика",
  "analytics.dailyTrendAria": "Динамика уникальных посетителей по дням",
  "analytics.readingCompletion": "Завершение чтения",
  "analytics.dailyMaximum": "Посетители/дневной максимум",
  "analytics.visitorCount": "{count} посетителей",
  "analytics.topLinks": "Популярные ссылки",
  "analytics.uniqueClickers": "Пользователи, перешедшие по ссылке",
  "analytics.linkTrendAria": "Ежедневный тренд для {label}",
  "analytics.noInteractions": "Взаимодействий по ссылкам пока нет.",
  "analytics.audienceOverview": "Обзор аудитории",
  "analytics.pageLevel": "Уровень страницы",
  "analytics.referrers": "Источники переходов",
  "analytics.devices": "Устройства",
  "analytics.countries": "Страны",
  "analytics.noData": "Данных пока нет",
  "analytics.durationSeconds": "{seconds} с",
  "analytics.durationMinutes": "{minutes} мин {seconds} с",
  "share.card": "Карточка для публикации",
  "share.variant.classic": "Классический",
  "share.variant.classicNote": "Тихий",
  "share.variant.contact": "Индекс",
  "share.variant.contactNote": "Структурированный",
  "share.variant.theme": "Версия {theme}",
  "share.variant.themeNote": "Тема",
  "share.variant.universal": "Универсальный",
  "share.saveFailed": "Не удалось сохранить",
  "share.styleUpdated": "Стиль обновлен.",
  "share.networkError": "Не удалось подключиться к сети",
  "share.linkCopied": "Ссылка скопирована",
  "share.copyFailed": "Не удалось скопировать",
  "share.text": "Моё 30-секундное знакомство",
  "share.failed": "Не удалось поделиться",
  "share.published": "Опубликовано",
  "share.draft": "Черновик",
  "share.style": "Стиль",
  "share.alt": "Карточка для публикации: {name}",
  "share.publishFirst": "Опубликовать, чтобы поделиться",
  "share.action": "Поделиться",
  "share.download": "Скачать",
  "share.openPublicPage": "Открыть общедоступную страницу",
  "share.chooseStyle": "Выберите стиль карты",
  "share.close": "Закрыть",
  "share.cardStyle": "Стиль карты",
  "share.chooseOne": "Выберите стиль",
  "share.chooseStyleAria": "Выберите стиль карты обмена",
  "share.saving": "Сохранение",
  "validation.body.placeholderDetail.legacyTemplate": "старый шаблон текста",
  "validation.body.placeholderDetail.ellipsis": "заполнитель `...`",
  "validation.body.placeholderDetail.sampleLink": "пример ссылки `https://example.com`",
  "validation.body.placeholderDetail.projectName": "заполнитель `项目名`",
  "validation.body.placeholderDetail.instruction": "текст инструкции по шаблону",
  "analytics.gate.signInTitle": "Войдите, чтобы посмотреть аналитику",
  "analytics.gate.signInCopy": "Данные о посещениях и взаимодействиях безопасно хранятся в панели управления.",
  "analytics.gate.signInAction": "Войти",
  "analytics.gate.proTitle": "Узнайте, дочитывают ли вашу страницу до конца.",
  "analytics.gate.proCopy": "Смотрите активное время чтения, долю дочитываний, распределение прогресса, динамику за 30, 90 и 365 дней и CTR ссылок.",
  "analytics.gate.proAction": "Посмотреть 30s Pro",
  "analytics.gate.emptyTitle": "После публикации здесь появятся данные.",
  "analytics.gate.emptyCopy": "Сначала завершите 30-секундную презентацию. После публикации вы увидите динамику посещений и взаимодействий.",
  "analytics.gate.emptyAction": "Начать создание",
  "analytics.gate.privacyNote": "Ежедневная агрегация по UTC · Анонимная дедупликация · Исходный IP не сохраняется",
  "handleEdit.previous": "Защищённые прежние адреса",
  "handleEdit.deadlines": "Перенаправление до {redirectDate}; защита до {releaseDate}.",
  "handleEdit.usePrevious": "Использовать этот адрес",
  "handleEdit.reclaimAvailable": "Вы можете вернуть этот прежний адрес.",
  "publish.handleReclaimed": "Возврат считается сменой адреса. Для текущего адреса начнутся новые 30 дней перенаправления и 180 дней защиты."
}
